import axiosBackEnd from "../config/axios/axios-back-end";

export const sampleTemplateGetConfig = async (id) => {
  const url = `/api/templates/${id}`;
  const response = await axiosBackEnd.get(url);
  return response.data;
};

export const sampleTemplateSetConfig = async ({ id, data }) => {
  const url = `/api/templates/${id}`;
  const response = await axiosBackEnd.put(url, data);
  return response.data;
};

export default {
  sampleTemplateGetConfig,
  sampleTemplateSetConfig,
};
